"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _commons = require("egov-ui-kit/utils/commons");

var _utils = require("egov-ui-kit/redux/app/utils");

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _PropertyInfoCard = require("../PropertyInfoCard");

var _PropertyInfoCard2 = _interopRequireDefault(_PropertyInfoCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale = (0, _localStorageUtils.getLocale)() || "en_IN";
// import { connect } from "react-redux";

var localizationLabelsData = (0, _utils.initLocalizationLabels)(locale);

var getAddressItems = function getAddressItems(properties) {
  var address = properties.address;

  return address && [
  // [

  {
    key: (0, _commons.getTranslatedLabel)("PT_PROPERTY_ADDRESS_CITY", localizationLabelsData),
    value: address.city || "NA"
  }, {
    key: (0, _commons.getTranslatedLabel)("PT_PROPERTY_ADDRESS_HOUSE_NO", localizationLabelsData),
    value: address.doorNo || "NA"
  }, {
    key: (0, _commons.getTranslatedLabel)("PT_PROPERTY_ADDRESS_COLONY_NAME", localizationLabelsData),
    value: address.buildingName || "NA"
  }, {
    key: (0, _commons.getTranslatedLabel)("PT_PROPERTY_ADDRESS_STREET_NAME", localizationLabelsData),
    value: address.street || "NA"
  }, {
    key: (0, _commons.getTranslatedLabel)("PT_PROPERTY_ADDRESS_MOHALLA", localizationLabelsData),
    value: (0, _commons.getTranslatedLabel)((properties.tenantId.replace('.', '_') + '_REVENUE_' + address.locality.code).toUpperCase(), localizationLabelsData) || "NA"
  }, {
    key: (0, _commons.getTranslatedLabel)("PT_PROPERTY_ADDRESS_PINCODE", localizationLabelsData),
    value: address.pincode || "NA"
  }, {
    key: (0, _commons.getTranslatedLabel)("PT_PROPERTY_ADDRESS_EXISTING_PID", localizationLabelsData),
    value: properties.oldPropertyId || "NA"
  }];
};

var PropertyAddressInfo = function PropertyAddressInfo(_ref) {
  var properties = _ref.properties,
      editIcon = _ref.editIcon;


  var addressItems = [];
  var header = 'PT_PROPERTY_ADDRESS_SUB_HEADER';
  if (properties) {
    addressItems = getAddressItems(properties);
  }

  return _react2.default.createElement(_PropertyInfoCard2.default, { editIcon: editIcon, items: addressItems, header: header });
};

exports.default = PropertyAddressInfo;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/propertyTax/Property/components/PropertyAddressInfo/index.js
// module id = 2279
// module chunks = 1143